import { create } from 'zustand'

import { OrgSigner } from '~/types'

type AddPasskeyStep = 'confirm' | 'create'

type AddPasskeyResolve = (signer: OrgSigner | undefined) => void

interface AddPasskeyDialogState {
  // Set while the dialog is open. Settles the caller's addNewPasskey() promise
  // when the dialog closes, with the new signer or undefined on cancel.
  resolve: AddPasskeyResolve | null
  step: AddPasskeyStep
  // Issued by the confirm step. Null when that step was skipped.
  confirmationId: string | null
  open: (params: { step: AddPasskeyStep; resolve: AddPasskeyResolve }) => void
  confirmed: (confirmationId: string) => void
  close: (signer?: OrgSigner) => void
}

export const useAddPasskeyDialogStore = create<AddPasskeyDialogState>()(
  (set, get) => ({
    resolve: null,
    step: 'create',
    confirmationId: null,
    open: ({ step, resolve }) => set({ resolve, step, confirmationId: null }),
    confirmed: (confirmationId) => set({ step: 'create', confirmationId }),
    close: (signer) => {
      get().resolve?.(signer)
      set({ resolve: null })
    },
  }),
)
